import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';
import { AxiosError } from 'axios';
import { API } from 'network/api';
import { UserPayload } from 'types/request';

export type UpdateUserPayload = Pick<
  UserPayload,
  'id' | 'name' | 'email' | 'phoneNumber' | 'reportingToUserEmailList'
>;

type UpdateUserConfig = {
  onSuccess?: () => void;
  onError?: () => void;
  onFinish?: () => void;
};

const useUpdateUser = (config?: UpdateUserConfig) => {
  const mutation = useMutation({
    mutationFn: (data: UpdateUserPayload) => API.put(`/user/${data.id}`, data),
    onSuccess: () => {
      message.success('User successfully edited');
      config?.onSuccess?.();
    },
    onError: (error) => {
      config?.onError?.();
      if (error instanceof AxiosError) {
        message.error(error?.response?.data?.title ?? error?.message);
      } else {
        message.error('Failed to edit user. Please try again.');
      }
    },
    onSettled: () => {
      config?.onFinish?.();
    },
  });

  return mutation;
};

export default useUpdateUser;
